const initialState = {
  globalLoading: false,
};

export function uiReducer(state = initialState, action) {
  switch (action.type) {
    case "GLOBAL_LOADING_START":
      return { ...state, globalLoading: true };

    case "GLOBAL_LOADING_STOP":
      return { ...state, globalLoading: false };

    default:
      return state;
  }
}
